import { render, staticRenderFns } from "./SectionIndex.vue?vue&type=template&id=5d44f373&"
import script from "./SectionIndex.vue?vue&type=script&lang=js&"
export * from "./SectionIndex.vue?vue&type=script&lang=js&"
import style0 from "./SectionIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports